module.exports = __webpack_public_path__ + "img/product0.faeb00bf.png";